/* eslint-disable
    func-names,
    no-underscore-dangle,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// This is a singleton service for storing information about the current user.
// It is a singleton Store and has all the expected properties of Store,
// but it's best to access it by injecting `User` as opposed to
// fetching it like a normal named Store.

const { gql } = require('@apollo/client');
const { getRoleGroup } = require('user-utils');

const GET_CURRENT_USER = gql`
  query getCurrentUser {
    currentUser {
      id
      userId: id
      accessibleClients: accessibleClientIds
      roles
      clients {
        id
        isPrincipalPerson
        permissions {
          banking
        }
      }
    }
  }
`;

const factory = function (Model, $q, $rootScope, AuthActions, benchLocation) {
  class User extends Model {
    static initClass() {
      this.prototype.$idName = '$id';

      this.prototype.$resource = 'security';

      this.prototype.$id = 'user';

      this.prototype._isImpersonating = false;

      this.prototype.userId = null;

      this.prototype.clientId = null;

      this.prototype.roles = [];

      this.prototype.accessibleClients = [];
    }

    authenticate(opts) {
      const promise = opts.reload ? this.$fetch() : this.$promise;
      return promise.then(() => {
        if (this.isLoggedIn()) {
          return this;
        }
        benchLocation.gotoLogin({ redirect: true });
        return $q.reject('Authentication Error');
      });
    }

    $init() {
      super.$init();
      this.$subscribe(AuthActions.authenticate(), this.authenticate);
    }

    isCurrentClientUnpaid() {
      return this.userHasRole('UNPAID_CLIENT');
    }

    isBookkeeper() {
      return this.userGroup() === 'BENCH';
    }

    isSuperUser() {
      return this.userHasRole('SUPERUSER');
    }

    isBankingSupportUser() {
      return this.userHasRole('BANKING_SUPPORT');
    }

    isTA() {
      return this.userGroup() === 'TAX_ACCOUNTANT';
    }

    isClient() {
      return this.userGroup() === 'CLIENT';
    }

    isTrial() {
      return ['TRIAL_QUALIFY', 'TRIAL_EXECUTE', 'TRIAL_REVIEW', 'TRIAL_CONVERT'].includes(
        this.inboxState,
      );
    }

    userGroup() {
      return getRoleGroup(this.roles);
    }

    isLoggedIn() {
      return this.roles.length > 0 && !this.userHasRole('ANONYMOUS');
    }

    isImpersonatingClient() {
      return this.clientId != null && this._isImpersonating;
    }

    getClientId() {
      // If clientId is defined (in the URL), use it
      if (this.clientId != null && this.clientId !== '') {
        return this.clientId;
      } else if (this.accessibleClients.length === 1) {
        // if only one client is accessible, pick this one
        return this.accessibleClients[0];
      }
      return null;
    }

    setClientId(clientId) {
      return this.$set({ clientId });
    }

    hasAccessToMultipleClients() {
      return this.accessibleClients.length > 1;
    }

    impersonateClient(clientId) {
      // disallow all impersonation to clients, and also when
      // impersonation is already in use.
      if (this.isClient() || this.isImpersonatingClient()) {
        return;
      }

      this.setClientId(clientId);
      return (this._isImpersonating = true);
    }

    stopImpersonatingClient() {
      if (!this.isImpersonatingClient()) {
        return;
      }

      this.setClientId(null);
      return (this._isImpersonating = false);
    }

    userHasRole(role) {
      return this.roles.includes(role);
    }

    $fetch() {
      this.$promise = this.$graphqlClient
        .query({ query: GET_CURRENT_USER })
        .then(res => {
          if (!res.data || !res.data.currentUser) {
            return $q.reject('Invalid response');
          }
          if (!res.data.currentUser.id) {
            // eslint-disable-next-line no-console
            console.log('No current user found, redirecting');
          }
          this.$set(res.data.currentUser);
          this.$cache();
          return this;
        })
        .catch(err => $q.reject(err));

      return this.$promise;
    }
  }
  User.initClass();

  return new User();
};

// represents the current user
const moduleDeps = [
  require('data/util').name,
  require('data/actions/auth').name,
  require('data/service/location').name,
];

module.exports = angular.module('bench.data.user', moduleDeps).factory('User', factory);
